export default __webpack_public_path__ + "static/media/practice-test-9.99d0dd70.csv";